import React from "react";

import StorefrontIcon from "@mui/icons-material/StorefrontOutlined";
import FactoryIcon from "@mui/icons-material/FactoryOutlined";
import DomainIcon from "@mui/icons-material/DomainOutlined";
import PublicIcon from "@mui/icons-material/Public";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import ArrowOutwardOutlinedIcon from "@mui/icons-material/ArrowOutwardOutlined";
import LightModeIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeIcon from "@mui/icons-material/DarkModeOutlined";

import "../styles/mici-ui.css";
import { AppConfig } from "../config/appConfig";

const TABS = [
  { id: 0, label: "Mercados Minoristas",  color: "#14B8A6", Icon: StorefrontIcon },
  { id: 2, label: "Parques Industriales", color: "#F59E0B", Icon: FactoryIcon },
  { id: 3, label: "Zonas Industriales",   color: "#8B5CF6", Icon: DomainIcon },
];

const formatCount = (n) => {
  if (n == null) return null;
  if (n >= 1000) return `${(n / 1000).toFixed(1)}k`.replace(".0k", "k");
  return String(n);
};

const HeaderAbove = ({
  activeTab,
  setActiveTab,
  theme,
  setTheme,
  tabCounts = {},
}) => {
  const toggleTheme = () =>
    setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <header className="px-header">
      <div className="px-header-left">
        <div className="px-brand">
          <div className="px-brand-mark" title="MICI">
            <PublicIcon style={{ fontSize: 20, color: "white" }} />
          </div>
          <div className="px-brand-text">
            <strong>MICI</strong>
            <span>Mapa Interactivo de Comercio Interno e Industria</span>
          </div>
        </div>
      </div>

      <nav className="px-tabs">
        {TABS.map((tab) => {
          const Icon = tab.Icon;
          const active = activeTab === tab.id;
          const count = formatCount(tabCounts[tab.id]);
          // Parques (2) y Zonas (3) son ArcGIS: la primera consulta puede
          // tardar y, si el usuario salta al tab antes de que termine, se
          // pierde una fracción de las features (race en `_update` de
          // esri-leaflet). Mientras `tabCounts[id]` esté null, el tab queda
          // deshabilitado con skeleton en su label y badge — así no puede
          // disparar la carga prematura.
          const isLoading = (tab.id === 2 || tab.id === 3) && tabCounts[tab.id] == null;
          return (
            <button
              key={tab.id}
              type="button"
              className={`px-tab ${active ? "is-active" : ""} ${isLoading ? "is-loading" : ""}`}
              style={active ? { "--c": tab.color } : undefined}
              onClick={isLoading ? undefined : () => setActiveTab(tab.id)}
              disabled={isLoading}
              aria-busy={isLoading}
              title={isLoading ? "Cargando datos…" : undefined}
            >
              <Icon style={{ fontSize: 16 }} />
              {isLoading ? (
                <span className="px-tab-skel px-tab-skel--label" aria-hidden />
              ) : (
                <span>{tab.label}</span>
              )}
              {/* Siempre rendea el badge para reservar el espacio — antes
                  aparecía cuando el count cargaba (null → número) y movía
                  el ancho del tab causando un flicker en el layout. */}
              {isLoading ? (
                <em className="px-tab-skel px-tab-skel--badge" aria-hidden />
              ) : (
                <em>{count != null ? count : "—"}</em>
              )}
            </button>
          );
        })}
      </nav>

      <div className="px-toolbar">
        <button
          type="button"
          className="px-icon-btn"
          onClick={toggleTheme}
          title={`Cambiar a tema ${theme === "dark" ? "claro" : "oscuro"}`}
          aria-label="Cambiar tema"
        >
          {theme === "dark" ? (
            <LightModeIcon fontSize="small" />
          ) : (
            <DarkModeIcon fontSize="small" />
          )}
        </button>

        <button
          type="button"
          className="px-staff-btn"
          onClick={() => {
            window.location.href = AppConfig.PORTAL_URL;
          }}
          title="Portal oficial de funcionarios PRODUCE"
        >
          <LoginOutlinedIcon
            className="px-staff-btn-icon"
            style={{ fontSize: 18 }}
          />
          <span>Acceso funcionarios</span>
          <ArrowOutwardOutlinedIcon
            className="px-staff-btn-arrow"
            style={{ fontSize: 14 }}
          />
        </button>
      </div>
    </header>
  );
};

export default HeaderAbove;
